module.exports = __webpack_public_path__ + "img/convenience-2-image.8ac2386c.jpg";